import { humanizePriceRange } from '../humanization';

export const getBankrotstvoConditions = (item) => {
  // Стоимость, Оформление банкротства

  const conditions = [];

  // Стоимость
  const { minSum, maxSum } = item;
  const priceValue = humanizePriceRange({
    priceRange: {
      from: minSum,
      to: maxSum,
    },
    allowZero: false,
    defaultValue: 'По запросу',
  });
  conditions.push({ value: priceValue === 'По запросу' ? priceValue : `${priceValue}/мес.`, description: 'Стоимость' });

  // Оформление банкротства
  const { timeBankrotstvo } = item;
  const timevalue = timeBankrotstvo ? `Около ${timeBankrotstvo} мес.` : 'Индивидуально';
  conditions.push({ value: timevalue, description: 'Оформление банкротства', wide: true });

  return conditions;
};
